import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="notFoundPage">
      <Helmet>
        <title>404: Another Loop | Khaled Asad</title>
      </Helmet>
      <section className="notFoundPanel" aria-labelledby="not-found-title">
        <div className="notFoundCopy">
          <p className="notFoundCode">404 / MAP ERROR</p>
          <h1 id="not-found-title">You found another loop.</h1>
          <p>
            The page you requested did not survive this cycle. The rest of the site is still operational.
          </p>
          <div className="notFoundActions">
            <Link className="notFoundLink" to="/">Respawn at home</Link>
            <Link className="notFoundLink notFoundLink--quiet" to="/portfolio">Open portfolio</Link>
          </div>
        </div>

        <figure className="notFoundMedia">
          <img src="/images/Returnal.gif" alt="A stranded astronaut caught in a dark repeating world" />
          <figcaption>SCOUT LOG: route missing; coffee reserves acceptable.</figcaption>
        </figure>
      </section>
    </div>
  );
}
